<template>
  <div>
    <div class="mb-6">
      <SegmentSelector v-model="segment" />
    </div>
    <DonutChart
      :data="pieData"
      class="w-60 h-60 mx-auto mb-8 overflow-hidden"
    />

    <div v-for="(subquestion, i) in barData" :key="i" class="mb-2">
      <ButtonPlus
        class="mb-4"
        button-class="bg-secondaryYellow"
        :status="!showSubquestions[subquestion.question]"
        @click="
          showSubquestions[subquestion.question] = !showSubquestions[
            subquestion.question
          ]
        "
      >
        {{ subquestion.name }}</ButtonPlus
      >

      <div v-show="showSubquestions[subquestion.question]" class="mb-10">
        <HorizontalBarChart
          bar-class="bg-secondaryYellow"
          :data="subquestion.values"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DonutChart from "@/components/DonutChart";
import HorizontalBarChart from "@/components/HorizontalBarChart";
import ButtonPlus from "@/components/ButtonPlus";
import data from "@/assets/data/data";
import IDS from "@/utils/ids";
import SegmentSelector from "@/components/SegmentSelector";
import colors from "@/utils/colors";
import { group } from "d3";

export default {
  components: {
    DonutChart,
    HorizontalBarChart,
    ButtonPlus,
    SegmentSelector,
  },
  props: {
    question: {
      type: Number,
      required: true,
    },
  },
  data() {
    const subquestions = Array.from(
      group(
        data[this.question].filter((e) => e[IDS.QUESTION_SUBNUMBER] !== ""),
        (d) => d[IDS.QUESTION_SUBNUMBER]
      )
    );

    const showSubquestions = {};

    subquestions.forEach(([key]) => {
      showSubquestions[key] = false;
    });

    return {
      data: data[this.question].filter(
        (e) => e[IDS.QUESTION_SUBNUMBER] === "" && e[IDS.ANSWER] !== IDS.NSNC
      ),
      subquestions,
      segment: "TOTAL",
      showSubquestions,
    };
  },
  computed: {
    pieData() {
      const pieColors = {
        [IDS.SI]: colors.secondaryYellow,
        [IDS.NO]: colors.tertiary,
        [IDS.NSNC]: colors.nsnc,
      };

      return this.data
        .map((e) => ({
          name: e[IDS.ANSWER],
          value: e[IDS[this.segment]],
          color: pieColors[e[IDS.ANSWER]],
          textColor: e[IDS.ANSWER] === IDS.SI ? "#000000" : "#ffffff",
        }))
        .sort((a, b) => (b.name === IDS.SI ? 1 : -1));
    },
    barData() {
      return this.subquestions
        .map(([key, value]) => ({
          name: value[0][IDS.QUESTION_MAIN],
          question: key,
          values: value
            .map((e) => ({
              name: e[IDS.ANSWER],
              value: e[IDS[this.segment]],
              compare: null,
            }))
            .sort((a, b) => b.value - a.value),
        }))
        .sort((a, b) => (b.question > a.question ? -1 : 1));
    },
  },
};
</script>

<style></style>
